import { FC } from 'react';
import { AddressType } from '@marriott/mi-groups-graphql';
import { ContactInfoSummaryProps } from './ContactInfoSummary.types';
import { StyledContactInfoSummary } from './ContactInfoSummary.styles';
import { SummaryRow } from '../../../../molecules';
import { useRfpStore } from '../../../../store';

export const ContactInfoSummary: FC<ContactInfoSummaryProps> = ({ labels }) => {
  const {
    nameLabel,
    emailLabel,
    phoneNumberLabel,
    businessLabel,
    personalLabel,
    accountSuffixText,
    businessNameLabel,
    addressLine1Label,
    addressLine2Label,
    countryLabel,
    cityLabel,
    stateLabel,
    zipCodeLabel,
    accountRepresentativeText,
  } = labels;

  const { contactInfoData } = useRfpStore();
  const { userInfo, addressInfo, gsoInfo } = contactInfoData;

  let state = '';
  try {
    const stateOption = JSON.parse(addressInfo.state);
    state = stateOption.value as string;
  } catch (error) {
    state = addressInfo.state;
  }

  return (
    <StyledContactInfoSummary>
      <div className="mb-2">
        {(userInfo.firstName || userInfo.lastName) && (
          <SummaryRow label={nameLabel} value={`${userInfo.firstName || ''} ${userInfo.lastName || ''}`} />
        )}
        {userInfo.email && <SummaryRow label={emailLabel} value={userInfo.email} />}
        {userInfo.phoneNumber && (
          <SummaryRow label={phoneNumberLabel} value={`${userInfo.callingCode.value} ${userInfo.phoneNumber}`} />
        )}
      </div>
      <div className="mb-2">
        {addressInfo.addressType && (
          <SummaryRow
            value={`${
              addressInfo.addressType === AddressType.BUSINESS ? businessLabel : personalLabel
            } ${accountSuffixText}`}
          />
        )}
        {addressInfo.companyName && <SummaryRow label={businessNameLabel} value={addressInfo.companyName} />}
        {addressInfo.addressLine1 && <SummaryRow label={addressLine1Label} value={addressInfo.addressLine1} />}
        {addressInfo.addressLine2 && <SummaryRow label={addressLine2Label} value={addressInfo.addressLine2} />}
        {addressInfo.city && <SummaryRow label={cityLabel} value={addressInfo.city} />}
        {state && <SummaryRow label={stateLabel} value={state} />}
        {addressInfo.zipcode && <SummaryRow label={zipCodeLabel} value={addressInfo.zipcode} />}
        {addressInfo.country.value && <SummaryRow label={countryLabel} value={addressInfo.country.value} />}
      </div>
      {(gsoInfo.name || gsoInfo.email) && (
        <div>
          <div className="t-subtitle-m">{accountRepresentativeText}</div>
          {gsoInfo.name && <SummaryRow label={nameLabel} value={gsoInfo.name} />}
          {gsoInfo.email && <SummaryRow label={emailLabel} value={gsoInfo.email} />}
        </div>
      )}
    </StyledContactInfoSummary>
  );
};
